function getEnvVariable<T>(key: string): T | undefined {
    const value = import.meta.env[key];
    if (typeof value === 'string') {
        // For arrays, we expect the value to be a comma-separated string
        if (value.includes(',')) {
            return value.split(',') as unknown as T;
        }

        // For objects, we expect the value to be a "JSON string"
        if (value.startsWith('[')) {
            try {
                return JSON.parse(value) as T;
            } catch (error) {
                console.error(`Error parsing JSON for key '${key}':`, error);
                return undefined;
            }
        }
        return value as unknown as T;
    }
    return undefined;
}

function debug(): boolean | undefined {
    return getEnvVariable<boolean>('VITE_DEBUG');
}

function environment(): string | undefined {
    return getEnvVariable<string>('VITE_ENVIRONMENT');
}

function apiEndpoint(): string | undefined {
    return getEnvVariable<string>('VITE_API_ENDPOINT');
}

function signalrEndpoint(): string | undefined {
    return getEnvVariable<string>('VITE_SIGNALR_ENDPOINT');
}

function amazonAWSUrl(): string | undefined {
    return getEnvVariable<string>('VITE_AMAZON_AWS_URL');
}

function adminPanelUrl(): string | undefined {
    return getEnvVariable<string>('VITE_ADMIN_PANEL_URL');
}

function baseUrl(): string | undefined {
    return getEnvVariable<string>('VITE_BASE_URL');
}

function websiteShortCode(): string | undefined {
    return shortcodeOverride || getEnvVariable<string>('VITE_WEBSITE_SHORT_CODE') || 'CG';
}

function getAWSBucketEndpoint(replacement: string): string | undefined {
    return amazonAWSUrl()?.replace('dynamic', replacement);
}

function chicksGroupBaseUrl(): string | undefined {
    return getEnvVariable<string>('VITE_CHICKS_GROUP_URL');
}

function clientId(): string | undefined {
    return getEnvVariable<string>('VITE_CLIENT_ID');
}

function openaiApiKey(): string | undefined {
    return getEnvVariable<string>('VITE_OPENAI_API_KEY');
}

let shortcodeOverride = '';

function setShortcodeOverride(shortcode: string): void {
    shortcodeOverride = shortcode;
}


export default this;

export {
    apiEndpoint,
    debug,
    environment,
    signalrEndpoint,
    amazonAWSUrl,
    adminPanelUrl,
    baseUrl,
    websiteShortCode,
    getAWSBucketEndpoint,
    chicksGroupBaseUrl,
    clientId,
    openaiApiKey,
    setShortcodeOverride
};
